import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * @param useFieldControl
 * @returns {{fieldControlProps: Object, handleChange: function}}
 */
export const useFieldControl = ({ value, defaultValue, onChange }) => {
  const [currentValue, setCurrentValue] = useState(value);

  const isControlled = typeof value !== 'undefined';

  const valueRef = useRef(value);

  useEffect(() => {
    if (value !== valueRef.current && value !== currentValue) {
      valueRef.current = value;
      setCurrentValue(value);
    }
  }, [value, currentValue]);

  const onChangeHandler = useCallback(
    (e) => {
      setCurrentValue(e.target.value);
      onChange && onChange(e.target.value, e);
    },
    [onChange]
  );

  const fieldControlProps = {
    ...(isControlled
      ? {
          value,
        }
      : {
          defaultValue,
        }),
  };

  return {
    fieldControlProps,
    handleChange: isControlled ? onChangeHandler : onChange,
  };
};
